// import {axiosInstance as axios} from '../redux/store';
import axios from 'axios'
import { toast } from "react-toastify"
import { store } from "../redux/provider"
import { logoutUser, setAccessToken } from '../redux/store';

const instance = axios.create({
    withCredentials: true
})

instance.interceptors.request.use(
    async (config: any) => {
        if (typeof store !== 'undefined' && store.getState() && store.getState().appState) {
            const accessToken = store.getState().appState.accessToken;
            if (accessToken) {
                config.headers['Authorization'] = `Bearer ${accessToken}`;
            }
        }
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response: any) => {
        return response
    },
    async (error: any) => {
        const lang = store.getState().appState.language
        const prevRequest = error?.config
        if (error?.response?.status === 401 && error?.response?.data?.message === 'Unauthorized: Expired token') {
            prevRequest.sent = true
            try {
                const responseToken = await instance.get(`${process.env.CLIENT_URL}/api/auth/refresh-token`, {withCredentials: true})
                prevRequest.headers['Authorization'] = `Bearer ${responseToken.data.accessToken}`
                setAccessToken({ payload: responseToken.data.accessToken });
                return instance(prevRequest)
            } catch (err) {
                store.dispatch(logoutUser())
                await instance.post(`${process.env.CLIENT_URL}/api/auth/logout`);
                    setTimeout(() => {
                        window.location.href = '/entrar'
                    }, 200)
            }
        // if (error?.response?.status === 401 && error?.response?.data?.message === 'Unauthorized: Expired token') {
        //     await instance.post(`${process.env.CLIENT_URL}/api/auth/logout`);
        //     store.dispatch(logoutUser())
        //     setTimeout(() => {
        //         window.location.href = '/entrar'
        //     }, 200)
        } else {
            if (error?.response?.data?.message === 'Duplicate user') {
                const message = lang === 'es' ? 'Ya existe un usuario con ese email' : 'Duplicate user'
                toast.error(message, { autoClose: 3000 })
            } else if (error?.response?.data?.message === 'No user with that email') {
                const message = lang === 'es' ? 'No existe usuario para ese email' : 'No user with that email'
                toast.error(message, { autoClose: 3000 })
            } else if (error?.response?.data?.message === 'Unauthorized') {
                const message = lang === 'es' ? 'Contraseña incorrecta' : 'Wrong password'
                toast.error(message, { autoClose: 3000 })
            } else if (error?.response?.data?.message === 'Error Mangopay, por favor inténtelo de nuevo más tarde') {
                const message = lang === 'es' ? 'Error Mangopay, por favor inténtelo de nuevo más tarde' : 'Mangopay error, please try it again later'
                toast.error(message, { autoClose: 3000 })
            } else if (error?.response?.status === 500) {
                const message = lang === 'es' ? 'Lo sentimos, nuestros servidores no se encuentran disponibles, inténtelo de nuevo más tarde' : 'Sorry, our servers are down, please try again later'
                toast.error(message, { autoClose: 3000 })
            }
        }
        return Promise.reject(error)
    }
)



export default class StpApi {
    //url = "http://localhost:1200/api"; //mi back
    url = `${process.env.CLIENT_URL}/api` //pre
    //url = `http://104.248.204.49:8081/api` //pre

    // constructor(url) {
    //     // this.url = url;
    // }

    // Methods with Authorization header    
    get(endpoint: any, axiosConfig: any) {
        return instance.get(`${this.url}${endpoint}`, this._getConfigWithAuthorizationHeader(axiosConfig))
    }

    getWithQueryParams(endpoint: any, params: any = {}, axiosConfig: any = {}) {
        const config = {
            ...this._getConfigWithAuthorizationHeader(axiosConfig),
            params: {...params}
        };
        return instance.get(`${this.url}${endpoint}`, config);
    }

    post(endpoint: any, data: any, axiosConfig: any) {
        return instance.post(`${this.url}${endpoint}`, data, this._getConfigWithAuthorizationHeader(axiosConfig));
    }

    put(endpoint: any, data: any, axiosConfig: any) {
        return instance.put(`${this.url}${endpoint}`, data, this._getConfigWithAuthorizationHeader(axiosConfig));
    }

    delete(endpoint: any, axiosConfig: any) {
        return instance.delete(`${this.url}${endpoint}`, this._getConfigWithAuthorizationHeader(axiosConfig));
    }

    // Methods without authorization header    

    getUnsigned(endpoint: any, axiosConfig: any) {
        return instance.get(`${this.url}${endpoint}`, axiosConfig)
    }

    postUnsigned(endpoint: any, data: any, axiosConfig: any) {
        return instance.post(`${this.url}${endpoint}`, data, axiosConfig);
    }

    putUnsigned(endpoint: any, data: any, axiosConfig: any) {
        return instance.put(`${this.url}${endpoint}`, data, axiosConfig);
    }

    deleteUnsigned(endpoint: any, axiosConfig: any) {
        return instance.delete(`${this.url}${endpoint}`, axiosConfig);
    }

    _getConfigWithAuthorizationHeader(axiosConfig: any) {
        return {}
        if (axiosConfig) {
            return {
                 ...axiosConfig,
                 headers: axiosConfig.headers 
                 ? {...axiosConfig.headers, 
                     ...this._getAuthorizationHeader() }
                 : {...this._getAuthorizationHeader()}
             }
         } else {
             return {
                headers: {...this._getAuthorizationHeader()}
             }
         }
    }

     _getAuthorizationHeader() {
         return { "authorization": store.getState().appState.accessToken };
     }

    getRefreshToken = () => {
        return instance.get(`${this.url}/auth/refresh-token`, { withCredentials: true })
    }
}